import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { themeVars } from '@sbercloud/figma-tokens-cloud-platform';
import { CardClient, SectionCarousel } from '../../helperComponents';
import { getCarouselProps } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function SectionClientsCarousel(_ref) {
  var items = _ref.items,
    props = _objectWithoutProperties(_ref, _excluded);
  var carouselProps = useMemo(function () {
    return getCarouselProps(props.layoutType);
  }, [props.layoutType]);
  return /*#__PURE__*/_jsx(SectionCarousel, _objectSpread(_objectSpread(_objectSpread({
    autoSwipe: 0
  }, props), carouselProps), {}, {
    gap: themeVars.dimension['1m'],
    children: items.map(function (item) {
      return /*#__PURE__*/_jsx(CardClient, _objectSpread({}, item), item.alt);
    })
  }));
}